module.exports = __webpack_public_path__ + "img/pump-40.5aa3ae86.svg";